import { memo } from 'react'

import CustomImage from '@/components/elements/images/image'

const DualPicturesImage = ({ image, index }) => (
  <div
    className={`${index > 0 ? 'hide-in-mobile' : ''} dual-pictures-image-container`}
    style={{ width: image.attributes.width, height: image.attributes.height }}
  >
    <CustomImage media={image.attributes} layout="fill" objectFit="contain" priority />
  </div>
)

export default memo(DualPicturesImage)
